export default "__VITE_ASSET__6e489d6d__"